(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('scopes', scopes);

    scopes.$inject = [];

    //Service for scope sharing between controllers
    function scopes() {
        var mem = {};
 
        return {
            store: function (key, value) {
                mem[key] = value;
            },
            get: function (key) {
                return mem[key];
            }
        };
    }
})();